import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-condition-legal-dialog',
  templateUrl: './terms-condition-legal-dialog.component.html',
  styleUrls: ['./terms-condition-legal-dialog.component.scss']
})
export class TermsConditionLegalDialogComponent {
  isActiveLegalTermsCondition: string= '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: {isActiveLegalTermsCondition: string},private dialogRef: MatDialogRef<TermsConditionLegalDialogComponent>){
    this.isActiveLegalTermsCondition = this.data.isActiveLegalTermsCondition;
  }

  close(isTrue: boolean){
    this.dialogRef.close(isTrue);
  }
}
